import { render } from "./CompareTest.vue?vue&type=template&id=567b9016&scoped=true"
import script from "./CompareTest.vue?vue&type=script&lang=js"
export * from "./CompareTest.vue?vue&type=script&lang=js"

import "./CompareTest.vue?vue&type=style&index=0&id=567b9016&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567b9016"]])

export default __exports__